import RRPSwitch from './RRPSwitch';

export default RRPSwitch;
